import { Component, Input  } from '@angular/core';
import { NavController } from 'ionic-angular';
import { WildlifeService } from '../../providers/wildlife-service';
import { Storage } from '@ionic/storage';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'wildlifelist',
  templateUrl: 'wildlifelist.html'
})

export class WildlifelistComponent {

 @Input('taxonomy') taxonomyToUse;
 @Input('taxonomylevel') taxonomylevelToUse;
 @Input('taxonomytitle') taxonomytitleToUse;

 wildlifeStored:any;
 wildlifeList:  any;
 wildlifeListO: any;
 taxonomy:      string;
 taxonomylevel: string;
 taxonomytitle: string; 
 searchTerm:    string = '';
 searchControl: FormControl;
 searching:     any = false;
 
  constructor(public navCtrl: NavController, public wildlifeService: WildlifeService, public storage: Storage) {
    this.taxonomylevel = 'classis';
    this.taxonomy = 'Mammalia';
    this.taxonomytitle = 'Mammals (Mammalia)';
    this.searchControl = new FormControl();    
     }

}

 /*
   ngAfterViewInit(){
     this.loadWildlifeData();     
    } 

  loadWildlifeData(){
   
    this.taxonomy = this.taxonomyToUse;
    this.taxonomylevel = this.taxonomylevelToUse;
    this.taxonomytitle = this.taxonomytitleToUse; 
    this.wildlifeStored = this.storage.get(this.taxonomy);
    //  console.log(this.taxonomy);    
    //  console.log(this.taxonomylevel);
      this.wildlifeService.fetchWildlife(this.taxonomy, this.taxonomylevel).then((wildlife) => { 
      this.wildlifeList  = JSON.parse(wildlife); 
      this.wildlifeListO = JSON.parse(wildlife);   
    
      console.log('hello')
        });  
  }


  ionViewDidLoad() {    
       this.searchControl.valueChanges.debounceTime(700).subscribe(search => {
       this.setFilteredItems();
       });
   }

   onSearchInput(){
        this.searching = true;
        console.log("searching"); 
    }

   
  filterItems(searchTerm){ 
        return this.wildlifeListO.filter((wildlife) => {
            return wildlife.label_en.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
        });      
    }

   setFilteredItems() {
      console.log("In setFilteredItem. Line75");
     this.wildlifeList = this.filterItems(this.searchTerm); 
     console.log(this.searchTerm);  
  }
  
  viewWildlifeDetail(wildlife): void { 
  this.navCtrl.push('Wildlifedetail', 
    { wildlife: wildlife }); 
    }
*/




// WEBPACK FOOTER //
// ./src/components/wildlifelist/wildlifelist.ts